export default "__VITE_ASSET__DnrWlbm5__"